import { useEffect , useState } from "react";
import { Link } from "react-router-dom";
import Counter from "./Counter";

import projectsData from "../Data/projectsData";
import Card from "../Component/Card";
import "../Styles/Home.css";
import "./ProjectsCarousel.css";

const Home = () => {

  // ===== Completed Projects =====
// const completedCardWidth = 290;
// const completedVisible = 4;
// const completedTotal = 12;

// const [completedIndex, setCompletedIndex] = useState(0);

// useEffect(() => {
//   const interval = setInterval(() => {
//     setCompletedIndex(prev =>
//       prev < completedTotal - completedVisible ? prev + 1 : 0
//     );
//   }, 3000);

//   return () => clearInterval(interval);
// }, []);

// const completedCardWidth = 290;
// const completedVisible = 4;
// const completedTotal = 12;

// const [completedIndex, setCompletedIndex] = useState(0);
// const [isCompletedHovered, setIsCompletedHovered] = useState(false);

// useEffect(() => {
//   if (isCompletedHovered) return;

//   const interval = setInterval(() => {
//     setCompletedIndex((prev) =>
//       prev < completedTotal - completedVisible ? prev + 1 : 0
//     );
//   }, 1000);

//   return () => clearInterval(interval);
// }, [isCompletedHovered]);


// // ===== Ongoing Projects =====
// const ongoingCardWidth = 290;
// const ongoingVisible = 4;
// const ongoingTotal = 10;

// const [ongoingIndex, setOngoingIndex] = useState(0);

// useEffect(() => {
//   const interval = setInterval(() => {
//     setOngoingIndex(prev =>
//       prev < ongoingTotal - ongoingVisible ? prev + 1 : 0
//     );
//   }, 3000);

//   return () => clearInterval(interval);
// }, []);
const projects = projectsData.filter(
  (p) => p.category === "completed"
);


  const [currentIndex, setCurrentIndex] = useState(0);

  const visibleCards = 4;
  const maxIndex = Math.max(0, projects.length - visibleCards);

  // Next Slide
  const nextSlide = () => {
    setCurrentIndex((prev) =>
      prev >= maxIndex ? 0 : prev + 1
    );
  };

  // Previous Slide
  const prevSlide = () => {
    setCurrentIndex((prev) =>
      prev <= 0 ? maxIndex : prev - 1
    );
  };

  // Auto Slide - Every 3 Seconds
  useEffect(() => {
    if (maxIndex === 0) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) =>
        prev >= maxIndex ? 0 : prev + 1
      );
    }, 3000);

    return () => clearInterval(interval);
  }, [maxIndex]);



// const ongoingCardWidth = 290;
// const ongoingVisible = 4;
// const ongoingTotal = 10;

// const [ongoingIndex, setOngoingIndex] = useState(0);
// const [isOngoingHovered, setIsOngoingHovered] = useState(false);

// useEffect(() => {
//   if (isOngoingHovered) return;

//   const interval = setInterval(() => {
//     setOngoingIndex((prev) =>
//       prev < ongoingTotal - ongoingVisible ? prev + 1 : 0
//     );
//   }, 1000);

//   return () => clearInterval(interval);
// }, [isOngoingHovered]);

const projectss = projectsData.filter(p => p.category === "ongoing");


  const [currentIndexx, setCurrentIndexx] = useState(0);

  const visibleCardss = 4;
  const maxIndexx = Math.max(0, projectss.length - visibleCardss);

  const nextSlidee = () => {
    setCurrentIndexx((prev) => (prev >= maxIndexx ? 0 : prev + 1));
  };

  const prevSlidee = () => {
    setCurrentIndexx((prev) => (prev <= 0 ? maxIndexx : prev - 1));
  };

useEffect(() => {
  const interval = setInterval(() => {
    setCurrentIndexx((prev) =>
      prev >= maxIndexx ? 0 : prev + 1
    );
  }, 3000);

  return () => clearInterval(interval);
}, [maxIndexx]);



  return (
    <>
    {/* hero banner  */}
<section className="video-banner">
  <video autoPlay muted loop playsInline>
    <source src="/video file/banner-video.mp4" type="video/mp4" />
  </video>
</section>

{/* <section className="hero-banner">
  <video
    className="hero-video"
    src="/video file/homes.MP4" autoPlay muted loop playsInline />
</section> */}



{/* HERO / SERVICES SECTION */}
<section className="services">
        <h4>Welcome to Swastika Infra</h4>
        <h2>India’s Leading Power Engineering & Infrastructure Company</h2>

        <div className="services-row">
          {/* <div className="box">
            <img src="/logo/Distribution.png" alt="Distribution" />
            <h4>Electrification</h4>
            <p>
              End-to-end EPC execution of reliable urban and rural power networks.
            </p>
          </div> */}

          {/* <div className="box">
            <img src="/logo/Cabling.png" alt="Cabling" />
            <h4>Underground Cabling</h4>
            <p>
              Trenchless underground cabling solutions for modern city
              infrastructure.
            </p>
          </div> */}

          {/* <div className="box">
            <img src="/logo/Grid.png" alt="Grid" />
            <h4>Grid</h4>
            <p>
              High-voltage substations and grid systems engineered for scale.
            </p>
          </div> */}

          {/* <div className="box">
            <img src="/logo/lightning.png" alt="Lightning" />
            <h4>Street Lighting</h4>
            <p>
              Smart and efficient lighting solutions for safer cities and villages.
            </p>
          </div> */}

          <div className="box">
            <img src="/logo/Distribution.png" alt="Distribution" />
            <h4>Transmission</h4>
            <p>
              End-to-end electrification systems for reliable urban and rural power networks
            </p>
          </div>

           <div className="box">
            <img src="/logo/Grid.png" alt="Grid" />
            <h4>Distribution</h4>
            <p>
              Efficient last-mile power delivery solutions ensuring stable, safe and uninterrupted electricity supply.
            </p>
          </div>

          <div className="box">
            <img src="/logo/Renewables.png" alt="Renewables" />
            <h4>Renewables</h4>
            <p>
              Power evacuation and grid connectivity for clean energy projects.
            </p>
          </div>
        </div>
  </section>


{/* innovation -------------------------- */}

<section className="innovation-nature">
  <div className="content">
    <h1>Innovation and Nature</h1>
    <p>
      We take all reasonable measures to protect the environment, both on-site
      and off-site, to prevent injury, damage, and inconvenience to people and
      property caused by pollution, noise, or other impacts of our operations.
      Our Site Environmental Plan is developed in accordance with the
      Employer’s Safety, Health, and Environmental (SHE) Manual and complies
      with the special conditions of the contract.
    </p>
  </div>
</section>


{/* completed project list -------- */}
{/* <section
  className="carousel-wrapper"
  onMouseEnter={() => setIsCompletedHovered(true)}
  onMouseLeave={() => setIsCompletedHovered(false)}
>
  <h2 className="heading">Completed Projects</h2>
  <div className="underline"></div>
  <div
    className="carousel"
    style={{
      transform: `translateX(-${completedIndex * completedCardWidth}px)`,
    }}
  >
          <Card id="JVVNL" img="/projects/project high quality/CP1.png" title="JVVNL Underground Cabling & Grid Substations Project" />
          <Card id="JVVNL-S "img="/projects/project high quality/CP2.jpeg" title="JVVNL Compact Substations Project " />
        //  <Card id="JDA " img="/projects/project high quality/CP3.jpeg" title="Underground Cabling HT/LT Project" /> 
          <Card id="J&A " img="/projects/project high quality/CP4.jpg" title="JVVNL & AVVNL Overhead Lines & Substations Project" />
          <Card id="JVVNL-LT "img="/projects/project high quality/CP5.jpeg" title="JVVNL Overhead Lines & Meter Connection Project" />
          <Card id="APDCL "img="/projects/project high quality/CP6.jpeg" title="APDCL Overhead lines & meter Connection Project" />
          <Card id="JVVNLs "img="/projects/project high quality/CP7.jpg" title="JVVNL Underground cabling & SCADA Project" />
          <Card id="UPCL "img="/projects/project high quality/CP8.jpg" title="UPCL Gas Insulated Substation Project" />
          <Card id="UHBVN "img="/projects/project high quality/CP9.jpg" title="UHBVN Grid Substation Project" />
          <Card id="WBSEDCL-UC "img="/projects/project high quality/CP10.jpeg" title="WBSEDCL Underground Cabling Project" />
          <Card id="GED-UC "img="/projects/project high quality/CP11.jpeg" title="GED Underground Cabling Project" />
          <Card id="GED-RMU "img="/projects/project high quality/CP12.jpeg" title="GED RMU Installation Project" />

  
  </div>
</section>  */}
<section className="project-showcase">
         <div className="project-showcase-header">
           <div className="project-showcase-heading">
             <span className="project-eyebrow">OUR WORK</span>
   
             <h2>
               {/* Projects That <span>Make an Impact.</span>*/}
               Completed Projects
             </h2>
   
             <p>
               Explore our completed infrastructure and electrical projects.
             </p>
           </div>
   
           <div className="project-navigation">
             <button
               type="button"
               className="project-nav-btn"
               onClick={prevSlide}
               aria-label="Previous projects"
             >
               &lt;
             </button>
   
             <button
               type="button"
               className="project-nav-btn"
               onClick={nextSlide}
               aria-label="Next projects"
             >
               &gt;
             </button>
           </div>
         </div>
   
         <div className="project-carousel-window">
           <div
             className="project-carousel-track"
             style={{
               "--project-index": currentIndex,
             }}
           >
   
               {projects.map((project) => (
                 <Link
                   to={`/project/${project.id}`}
                   className="project-showcase-card"
                   key={project.id}
                 >
                   <div className="project-showcase-image">
                     <img
                       src={project.image}
                       alt={project.title}
                       loading="lazy"
                     />
   
                     <div className="project-image-overlay">
                       <span>{project.category}</span>
                     </div>
                   </div>
   
                   <div className="project-showcase-info">
                     <h3>{project.title}</h3>
   
                     <span className="project-card-arrow">
                       &#8599;
                     </span>
                   </div>
                 </Link>
               ))}
   
           </div>
         </div>
   
         <div className="project-carousel-footer">
           <span>
             {String(currentIndex + 1).padStart(2, "0")}
             {" — "}
             {String(Math.min(currentIndex + visibleCards, projects.length)).padStart(2, "0")}
           </span>
   
           <div className="project-progress">
             <div
               className="project-progress-bar"
               style={{
                 width: `${((currentIndex + 1) / (maxIndex + 1)) * 100}%`,
               }}
             />
           </div>
   
           <span>
             {String(projects.length).padStart(2, "0")} PROJECTS
           </span>
         </div>
  </section>
      

{/* Completed Projects Banner */}
<section className="completed-image" style={{ backgroundImage: `linear-gradient(rgba(0,0,0,.6), rgba(0,0,0,.6)), url(${process.env.PUBLIC_URL}/projects/projects/homecomplete.png)` }} >

        <div className="completed-overlay">
          <p>Paving Roads to Progress, Building India’s Future</p>
          <h2>Completed Projects</h2>
          <Link to="/projects/#complete"><button>KNOW MORE</button></Link>
        </div>
  </section>



 {/* ongoing project list -------- */}
{/* <div
  className="carousel-wrapper"
  onMouseEnter={() => setIsOngoingHovered(true)}
  onMouseLeave={() => setIsOngoingHovered(false)}
>
  //  <p className="subtitle">Building Pathways, Powering Progress</p> 
  <h2 className="heading">Ongoing Projects</h2>
  <div className="underline"></div>

  <div className="carousel" style={{ transform: `translateX(-${ongoingIndex * ongoingCardWidth}px)`,
    }}
  >
    <Card id= "AVVNL" img="/projects/project high quality/OP1.jpeg" title="AVVNL Feeder Segregation Project" />
    <Card id= "HPSEBL" img="/projects/project high quality/o.jpg" title="HPSEBL GIS Sub-Stations Construction Project" />
    <Card id= "MGVCL" img="/projects/project high quality/OP3.jpeg" title="MGVCL Underground Cabling Project" />
    <Card id= "RRVPNL" img="/projects/project high quality/3.jpeg" title="RRVPNL 132 KV grid Substation Projects along with associated lines" />
    <Card id= "RSDCL" img="/projects/project high quality/OP5.jpg" title="RSDCL 220 KV grid Substation Projects along with associated lines" />
    <Card id= "WBSEDCL" img="/projects/project high quality/OP6.jpeg" title="WBSEDCL Underground Cabling Project" />
    <Card id= "GED-SOLAR" img="/projects/project high quality/2.jpeg" title="WBSEDCL  Solar Park  Project" />
    <Card id= "GED" img="/projects/project high quality/OP7.jpeg" title="GED RMU Installation Project" />
    <Card id= "WBSEDCL-SOLAR-pump" img="/projects/project high quality/1.jpeg" title="MSEDCL Solar Pump Project" />
    // <Card id= "MSEDCL-UC" img="/projects/project high quality/OP10.jpg" title="MSEDCL Underground Cabling Project" />

    

    


  </div>
</div>  */}
<section className="project-showcase">
      <div className="project-showcase-header">
        <div className="project-showcase-heading">
          <span className="project-eyebrow">OUR WORK</span>

          <h2>
            {/* Projects That <span>Make an Impact.</span>*/}
            Ongoing Projects
          </h2>

           <p>
            Explore our ongoing infrastructure and electrical projects.
           </p> 
        </div>

        <div className="project-navigation">
          <button
            type="button"
            className="project-nav-btn"
            onClick={prevSlidee}
            aria-label="Previous projects"
          >
            &lt;
          </button>

          <button
            type="button"
            className="project-nav-btn"
            onClick={nextSlidee}
            aria-label="Next projects"
          >
            &gt;
          </button>
        </div>
      </div>

      <div className="project-carousel-window">
        <div
          className="project-carousel-track"
          style={{
            "--project-index": currentIndexx,
          }}
        >

            {projectss.map((project) => (
              <Link
                to={`/project/${project.id}`}
                className="project-showcase-card"
                key={project.id}
              >
                <div className="project-showcase-image">
                  <img
                    src={project.image}
                    alt={project.title}
                    loading="lazy"
                  />

                  <div className="project-image-overlay">
                    <span>{project.category}</span>
                  </div>
                </div>

                <div className="project-showcase-info">
                  <h3>{project.title}</h3>

                  <span className="project-card-arrow">
                    &#8599;
                  </span>
                </div>
              </Link>
            ))}

        </div>
      </div>

      <div className="project-carousel-footer">
        <span>
          {String(currentIndexx + 1).padStart(2, "0")}
          {" — "}
          {String(Math.min(currentIndexx + visibleCardss, projectss.length)).padStart(2, "0")}
        </span>

        <div className="project-progress">
          <div
            className="project-progress-bar"
            style={{
              width: `${((currentIndexx + 1) / (maxIndex + 1)) * 100}%`,
            }}
          />
        </div>

        <span>
          {String(projectss.length).padStart(2, "0")} PROJECTS
        </span>
      </div>
  </section>


{/* ongoing Projects Banner */}
<section className="completed-image" style={{ backgroundImage: `linear-gradient(rgba(0,0,0,.6), rgba(0,0,0,.6)), url(${process.env.PUBLIC_URL}/projects//projects/homeongiong.png)` }} >
        <div className="completed-overlay">
          <p>Engineering Success, Transforming The Nation</p>
          <h2>Ongoing Projects</h2>
          <Link to="./projects/#current"><button>KNOW MORE</button></Link>
        </div>
  </section>





{/* our presence  */}

        {/* <section className="section-presence" id="section-presences">
            <h1>Our Presence</h1>

            <p className="presence">
              Swastika Infra Ltd is committed to shaping a sustainable and progressive future with a global vision.
              We continuously innovates, embraces cutting-edge technology, and upholds the highest standards of quality and sustainability.
            </p>

            <div className="stats-section">  

              <div className="stats-image">
                <img src="/images/MAP2.png" alt="Map" />
              </div>

              <div className="stats-column">
                <Counter value={15} label="Years of Experience" />
                <Counter value={1500} label="Orders Book" />
                <Counter value={150} label="Staff" />
                <Counter value={30} label="Projects Completed" />
                <Counter value={2000} label="Villages Electrified" />
              </div>

            </div>

            <p className="presence">
              Engineering Excellence Across Roads, Rails, and Renewables
            </p>
        </section> */}

<section className="section-presence" id="section-presences">
  <h1>Our Presence</h1>

  <p className="presence">
    Swastika Infra Ltd is committed to shaping a sustainable and progressive future with a global vision.
    We continuously innovates, embraces cutting-edge technology and upholds the highest standards of quality and sustainability.
  </p>

  <div className="stats-section">  

    <div className="stats-image">
      <img src="/images/m.png" alt="Map" />
    </div>

    <div className="stats-column">
      <Counter value={15} label="Years of Experience" />
      <Counter value={1500} label="Orders Book" suffix="Cr.+" /> 
      <Counter value={200} label="Staff" />
      <Counter value={36} label="Projects Completed" />
      <Counter value={2000} label="Villages Electrified" />
    </div>

  </div>

  <p className="presence">
  Engineering Excellence across Roads, Power and Renewables
  </p>
    </section>





{/* our client  */}
<section className="our-clients">
  <h2>Our Clientele</h2>

  <div className="logo-slider">
    <div className="logo-track">

      <div className="logo-set">
        <Link to={"https://energy.rajasthan.gov.in/rvpnl"}><img src="/logo/RRVPNL.jpg" /></Link>
        <Link to={"https://energy.rajasthan.gov.in/avvnl"}><img src="/logo/AVVNL.jpg" /></Link>
        <Link to={"https://hpseb.in"}><img src="/logo/HPSEBL.jpg" /></Link>
        <Link to={"https://www.wbsedcl.in"}><img src="/logo/WBSEDCL.jpg" /></Link>
        <Link to={"https://www.mgvcl.com"}><img src="/logo/MGVCL.jpg" /></Link>
        <Link to={"https://www.goa.gov.in"}><img src="/logo/GOA.jpg" /></Link>
        <Link to={"https://energy.rajasthan.gov.in/rrecl"}><img src="/logo/RSDCL.jpg" /></Link>
        <Link to={""}><img src="/logo/maha.jpg" /></Link>
        <Link to={"https://energy.rajasthan.gov.in/jvvnl"}><img src="/logo/JVVNL.jpg" /></Link>
        <Link to={"https://www.upcl.org"}><img src="/logo/UPCL.jpg" /></Link>
        <Link to={"https://www.apdcl.org"}><img src="/logo/APDCL.jpg" /></Link>
        <Link to={"https://jda.urban.rajasthan.gov.in"}><img src="/logo/JDA.jpg" /></Link>
        <Link to={"https://uhbvn.org.in"}><img src="/logo/UHBVN.jpg" /></Link>
        
        
    
      </div> 

       
      <div className="logo-set">
        <Link to={"https://energy.rajasthan.gov.in/rvpnl"}><img src="/logo/RRVPNL.jpg" /></Link>
        <Link to={"https://energy.rajasthan.gov.in/avvnl"}><img src="/logo/AVVNL.jpg" /></Link>
        <Link to={"https://hpseb.in"}><img src="/logo/HPSEBL.jpg" /></Link>
        <Link to={"https://www.wbsedcl.in"}><img src="/logo/WBSEDCL.jpg" /></Link>
        <Link to={"https://www.mgvcl.com"}><img src="/logo/MGVCL.jpg" /></Link>
        <Link to={"https://www.goa.gov.in"}><img src="/logo/GOA.jpg" /></Link>
        <Link to={"https://energy.rajasthan.gov.in/rrecl"}><img src="/logo/RSDCL.jpg" /></Link>
        <Link to={""}><img src="/logo/maha.jpg" /></Link>
        <Link to={"https://energy.rajasthan.gov.in/jvvnl"}><img src="/logo/JVVNL.jpg" /></Link>
        <Link to={"https://www.upcl.org"}><img src="/logo/UPCL.jpg" /></Link>
        <Link to={"https://www.apdcl.org"}><img src="/logo/APDCL.jpg" /></Link>
        <Link to={"https://jda.urban.rajasthan.gov.in"}><img src="/logo/JDA.jpg" /></Link>
        <Link to={"https://uhbvn.org.in"}><img src="/logo/UHBVN.jpg" /></Link>

      </div>

    </div>
  </div>
</section> 




    </>
  );
};






export default Home;
